import React, { FC } from 'react';
import { font as initialFont } from '@styles/fonts';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { localTime } from '@helpers';
import { NCFileBatchEventsProps } from '@v2/pages/common/components/NCFileBatchEvents';

interface EventTimeDisplayProps extends Pick<NCFileBatchEventsProps, 'C' | 'font'> {
  timeValue: string | Date;
}

const EventTimeDisplay: FC<EventTimeDisplayProps> = ({ timeValue, C, font = initialFont }) => {
  if (!timeValue) return null;

  const momentTime = localTime(timeValue);

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'baseline',
      }}
    >
      <Text style={[{ color: C('Label/Light/Tertiary') }]}>
        {`${momentTime.format('DD-MMM')} ${i18n.t('at')} `}
        <Text style={[font['Time 3']]}>{momentTime.format('HH')}</Text>
        <Text style={[font['Caption 1']]}>:</Text>
        <Text style={[font['Time 3']]}>{momentTime.format('mm')}</Text>
        <Text style={[font['Caption 1']]}>:</Text>
        <Text style={[font['Time 4']]}>{momentTime.format('ss')}</Text>
      </Text>
    </View>
  );
};

export default EventTimeDisplay;
